// app/PostHogPageView.tsx
"use client";
import { usePathname, useSearchParams } from "next/navigation";
import { useEffect } from "react";
import { usePostHog } from "posthog-js/react";

export default function PostHogPageView(): null {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const posthog = usePostHog();
  // Track pageviews
  useEffect(() => {
    if (pathname && posthog) {
      let url = window.origin + pathname;
      if (searchParams.toString()) {
        url = url + `?${searchParams.toString()}`;
      }
      posthog.capture("$pageview", {
        $current_url: url,
      });
    }
    try {
      import("react-facebook-pixel")
        .then((x) => x.default)
        .then((ReactPixel) => {
          console.log("Loading Facebook Pixel...");
          ReactPixel.init(process.env.NEXT_PUBLIC_FACEBOOK_PIXEL_ID as string);
          ReactPixel.pageView();
        });
    } catch (err) {
      console.error("Error loading Facebook Pixel", err);
    }
  }, [pathname, searchParams, posthog]);

  return null;
}
